import { FC } from 'react';

import { OnboardingStatus as OnboardingStatusType } from 'api/types/entity';

import { OnboardingStatus } from '../../components/OnboardingStatus';

import { OnboardingSuccessStatusFeature } from './OnboardingSuccessStatusFeature';

export type ClientOnboardingStatusFeatureProps = {
  onboardingStatus: OnboardingStatusType;
};

export const ClientOnboardingStatusFeature: FC<
  ClientOnboardingStatusFeatureProps
> = ({ onboardingStatus }) => {
  if (onboardingStatus === 'success') {
    return <OnboardingSuccessStatusFeature />;
  }

  return <OnboardingStatus onboardingStatus={onboardingStatus} />;
};
